export function CreateStreeStyle(map) {
  let street = map.getStreetView()
  street.setOptions({
    addressControlOptions: {
      position: google.maps.ControlPosition.BOTTOM_CENTER,
    },
    enableCloseButton: true,
  })
}
